import { getStaticImageUrl } from '@utils/createImageUrl';

const FourteenDay = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <>
      {isMobile ? (
        <img
          className="for-lawyer-advice-phone-noti view-on-visible"
          alt="의뢰인 전화상담 10분 전 알림"
          src={getStaticImageUrl({ fileName: 'preview/mobile-noti.png' })}
        />
      ) : (
        <img
          className="for-lawyer-advice-phone-noti view-on-visible"
          alt="의뢰인 전화상담 10분 전 알림"
          src={getStaticImageUrl({ fileName: 'preview/mobile-noti-desktop.png' })}
        />
      )}

      <div className="for-lawyer-dayplus-title view-on-visible">
        <h2 className="for-lawyer-day-title">Day</h2>
        <span className="for-lawyer-day-plus-number-title">+14</span>
      </div>
      <p className="for-lawyer-day-desc view-on-visible">
        로톡을 시작한 지 벌써 2주가 지났다. <br />
        <span className="for-lawyer-day-desc-bold">예약된 상담 10분 전에 알림톡과 앱 푸시&nbsp;</span>
        {isMobile && <br />}
        <span className="for-lawyer-day-desc-bold-mobile">메시지를 통해 </span>
        {!isMobile && <br />}알림을 보내준다. <br />
        <br />
        평소 스케줄 관리에 꼼꼼한 편이지만, 덕분에 놓치지 않고 {!isMobile && <br />}상담을 진행할 수 있어 편리하다.
      </p>
    </>
  );
};

export default FourteenDay;
